const nb = {
  common: {
    save: "Lagre",
    cancel: "Avbryt",
    delete: "Slett",
    edit: "Rediger",
    back: "Tilbake",
    close: "Lukk",
    loading: "Laster…",
    saving: "Lagrer…",
    add: "Legg til",
    update: "Oppdater",
    confirm: "Bekreft",
    all: "Alle",
    perMonth: "/MND",
    perMonthLabel: "Pr. måned",
    perYearLabel: "Pr. år",
    somethingWrong: "Noe gikk galt",
    signOut: "Logg ut",
    signedOut: "Du er logget ut",
    previous: "Forrige",
    next: "Neste",
    nav: {
      home: "Hjem",
      subscriptions: "Avtaler",
      add: "Legg til",
      salary: "Inntekt",
      income: "Inntekt",
      profile: "Profil",
    },
    language: "Språk",
    english: "Engelsk",
    norwegian: "Norsk (Bokmål)",
  },
  landing: {
    eyebrow: "Personlig økonomi",
    headline: "Se din økonomiske virkelighet.",
    body: "VISIKT samler dine faste utgifter, lønnsutvikling og reelle kjøpekraft på ett sted. Ingen budsjettering. Ingen pekefinger. Bare klarhet.",
    getStarted: "Kom i gang",
    haveAccount: "Jeg har allerede konto",
    pillars: "TO PILARER",
    pillar1Title: "Faste utgifter",
    pillar1Body:
      "Få full oversikt over alt som trekkes hver måned — strømming, programvare, telekom, trening. Kategorisert, beregnet og synlig.",
    pillar2Title: "Lønn & kjøpekraft",
    pillar2Body:
      "Sammenlign lønnsvekst med norsk KPI-inflasjon. Se reallønnsveksten din år for år.",
    footerYear: "VISIKT / 2026",
    footerScope: "NORGE-FØRST",
    login: "Logg inn",
    pricing: "Priser",
  },
  footer: {
    faq: "FAQ",
    partOf: "en del av",
    company: "VIKEEP AS",
    about: "Om oss",
    privacy: "Personvern",
  },
  auth: {
    welcomeBack: "Velkommen tilbake",
    newAccount: "Ny konto",
    forgot: "Nullstill passord",
    signInHeadline: "Logg inn.",
    signUpHeadline: "Opprett konto.",
    forgotHeadline: "Glemt passord.",
    subtitle: "Se din økonomiske virkelighet — uten støy.",
    forgotSubtitle: "Vi sender deg en lenke for å sette et nytt passord.",
    continueGoogle: "Fortsett med Google",
    continueApple: "Fortsett med Apple",
    appleFailed: "Innlogging med Apple mislyktes",
    or: "eller",
    name: "Navn",
    email: "E-post",
    password: "Passord",
    passwordHint: "Minst 8 tegn",
    submitSignIn: "Logg inn",
    submitSignUp: "Opprett konto",
    submitForgot: "Send lenke",
    waiting: "Vent…",
    forgotLink: "Glemt passord?",
    noAccount: "Ingen konto?",
    createOne: "Opprett en",
    haveAccount: "Har du allerede konto?",
    backToSignIn: "Tilbake til innlogging",
    googleFailed: "Kunne ikke logge inn med Google",
    invalidEmail: "Ugyldig e-postadresse",
    passwordMin: "Minst 8 tegn",
    accountCreated: "Konto opprettet. Du er logget inn.",
    resetSent: "Sjekk e-posten din for en lenke til å nullstille passordet.",
    passwordUpdated: "Passordet er oppdatert.",
    newPasswordHeadline: "Sett nytt passord.",
    newPasswordBody: "Velg et nytt passord på minst 8 tegn.",
    newPasswordPlaceholder: "Nytt passord",
    savePassword: "Lagre passord",
  },
  register: {
    eyebrow: "Kom i gang",
    headline: "Opprett din VISIKT-konto.",
    subtitle: "Se din økonomiske virkelighet — uten støy.",
    firstName: "Fornavn",
    lastName: "Etternavn",
    postalCode: "Postnummer",
    city: "Poststed",
    country: "Land",
    phone: "Telefonnummer",
    occupation: "Yrke",
    confirmPassword: "Bekreft passord",
    submit: "Opprett konto",
    checkEmail: "Sjekk e-posten din for å bekrefte kontoen.",
    errors: {
      required: "Påkrevd",
      confirmMismatch: "Passordene er ikke like",
      phone: "Skriv inn et gyldig telefonnummer",
      postalNo: "Norsk postnummer må være 4 sifre",
      signupFailed: "Vi fikk ikke opprettet kontoen. Send oss detaljene under, så ordner vi det.",
      alreadyRegistered:
        "Denne e-posten er allerede registrert. Prøv å logge inn eller tilbakestille passordet.",
      agreeRequired: "Du må godta Brukervilkårene og Personvernerklæringen for å fortsette.",
    },
    agreeTos:
      "Jeg godtar <tosLink>Brukervilkårene</tosLink> og <privLink>Personvernerklæringen</privLink>.",
  },
  nudge: {
    subs: "Du har {{count}} abonnementer. Gratis dekker 3 — oppgrader til Pro for ubegrenset.",
    salary:
      "Du har {{count}} år med lønnshistorikk. Gratis dekker 3 — oppgrader for full tidslinje.",
    cta: "Oppgrader",
  },
  occupation: {
    label: "Yrke",
    placeholder: "Velg yrke",
    student: "Student",
    employee: "Ansatt",
    other: "Annet",
  },
  gate: {
    moreCta: "+{{count}} til — oppgrader for å se alle",
    moreSubsAria: "Oppgrader for å se {{count}} flere abonnementer",
    moreSalaryAria: "Oppgrader for å se {{count}} flere lønnsoppføringer",
    moreYearsAria: "Oppgrader for å se {{count}} flere år med historikk",
    statsNote: "Basert på dine 3 øverste · oppgrader for fulle summer",
    upgrade: "Oppgrader til Pro",
    cpiTitle: "Se hele inflasjonshistorikken din",
    cpiBody:
      "Gratis viser kun inneværende år. Oppgrader for å sammenligne hvert år av lønnen din mot norsk KPI.",
    statsLockedTitle: "Full statistikkutforsker",
    statsLockedBody:
      "Kumulativ vekst, CAGR og reelle verditall over flere år er tilgjengelig på Pro.",
  },
  contact: {
    eyebrow: "Support",
    headline: "Vi hjelper deg.",
    subtitle: "Fortell oss hva som skjedde, så svarer vi raskt.",
    name: "Navn",
    phone: "Telefon",
    message: "Melding",
    describe: "Beskriv problemet du opplever",
    describePlaceholder: "Hva gikk galt, hva prøvde du å gjøre…",
    submit: "Send melding",
    autoIntro: "Jeg fikk et problem: {{reason}}\n\nDetaljer:",
    resetSuggestion: "Den e-posten har allerede en konto. Vil du ha en tilbakestillingslenke?",
    resetAction: "Send tilbakestillingslenke",
    receivedEyebrow: "Mottatt",
    receivedHeadline: "Takk — vi har det.",
    receivedBody: "Et menneske svarer på e-post så snart som mulig.",
    backHome: "Til forsiden",
    errors: {
      description: "Skriv en melding (minst 10 tegn).",
      submitFailed: "Noe gikk galt under sending av meldingen din. Prøv igjen.",
    },
  },

  completeProfile: {
    eyebrow: "Ett steg til",
    headline: "Fullfør profilen din.",
    subtitle: "Noen få detaljer vi trenger før du fortsetter.",
    submit: "Lagre og fortsett",
    saved: "Profil lagret.",
    agreeTos:
      "Jeg godtar <tosLink>Brukervilkårene</tosLink> og <privLink>Personvernerklæringen</privLink>.",
    agreeRequired: "Du må godta Brukervilkårene og Personvernerklæringen for å fortsette.",
  },
  plans: {
    eyebrow: "Velg plan",
    headline: "Finn planen som passer.",
    body: "Start gratis. Oppgrader når du er klar — kassen åpner snart.",
    upgradeSoon: "Oppgrader til Pro",
    checkoutSoon: "Kassen er utilgjengelig — prøv igjen om litt.",
    startProMonthly: "Start Pro — månedlig",
    startProYearly: "Start Pro — årlig",
    keepPro: "Behold Pro (angre oppsigelse)",
    currentPlan: "Nåværende plan",
    free: {
      continueFree: "Fortsett på Gratis",
      continue: "Fortsett",
    },
    renewalInfoMonthly:
      "{{price}} NOK/måned, inkl. MVA der det er aktuelt. Fornyes automatisk hver måned til du sier opp. Se <tosLink>Brukervilkårene</tosLink>.",
    renewalInfoYearly:
      "{{price}} NOK/år, inkl. MVA der det er aktuelt. Fornyes automatisk hvert år til du sier opp. Se <tosLink>Brukervilkårene</tosLink>.",
    withdrawalAck:
      "Jeg godtar <tosLink>Brukervilkårene</tosLink>, ber om at VISIKT Pro starter umiddelbart, og forstår at jeg taper den 14 dagers angreretten når tjenesten er fullt levert.",
    withdrawalRequired:
      "Godta Brukervilkårene og merknaden om umiddelbar start / angrerett for å fortsette.",
  },
  checkoutReturn: {
    finalizing: "Bekrefter abonnementet ditt…",
    confirmation: {
      eyebrow: "Ordrebekreftelse",
      headline: "Alt er klart — velkommen til VISIKT Pro.",
      intro:
        "Ta vare på denne bekreftelsen. Den dokumenterer avtalen du har inngått med VIKEEP AS.",
      operator: "Tilbyder",
      operatorValue: "VIKEEP AS · org.nr 938 008 272 · Oslo, Norge",
      contact: "Kontakt",
      plan: "Plan",
      planValue: "VISIKT Pro",
      cycleMonthly: "Faktureres månedlig",
      cycleYearly: "Faktureres årlig",
      price: "Pris",
      priceMonthly: "{{price}} NOK / måned (inkl. MVA der det er aktuelt)",
      priceYearly: "{{price}} NOK / år (inkl. MVA der det er aktuelt)",
      renewal: "Fornyelse",
      renewalMonthly:
        "Fornyes automatisk hver måned til den til enhver tid gjeldende prisen, inntil du sier opp.",
      renewalYearly:
        "Fornyes automatisk hvert år til den til enhver tid gjeldende prisen, inntil du sier opp.",
      purchasedAt: "Kjøpt",
      withdrawalHeading: "Angrerett",
      withdrawalAckLabel: "Du godtok",
      withdrawalAckText:
        "Jeg godtok Brukervilkårene, ba om at VISIKT Pro starter umiddelbart, og bekreftet at jeg taper den 14 dagers angreretten når tjenesten er fullt levert.",
      manage: "Du kan si opp eller nedgradere når som helst fra profilen din.",
      termsLinkLabel: "Brukervilkårene",
      download: "Last ned bekreftelse",
      continue: "Fortsett til dashbordet",
      filename: "visikt-pro-bekreftelse",
    },
  },
  dashboard: {
    eyebrow: "Oversikt",
    adviceNotice:
      "Kun til informasjon — ikke økonomisk rådgivning. Tallene beregnes fra dine opplysninger og offisiell KPI-data og kan bli revidert.",
    hello: "God dag, {{name}}",
    fixedRing: "FASTE",
    fixedMonthly: "FASTE KOSTNADER / MND",
    perYear: "{{value}} / år",
    activeOne: "aktiv",
    activeMany: "aktive",
    emptySubs: "Legg til ditt første abonnement →",
    purchasingPower: "KJØPEKRAFT",
    realGrowth: "REALVEKST",
    emptySalary: "Ingen lønnsdata lagt til ennå",
    grossSalary: "Lønn (brutto)",
    cpiInflation: "Inflasjon",
    cpiProvisional: "Foreløpig (12-mnd.)",
    yoy: "YoY",
    activeSubs: "AKTIVE ABONNEMENT",
    seeAll: "Se alle →",
    emptyActive: "Ingen aktive avtaler enda.",
    categories: "KATEGORIER",
    newSub: "Nytt abonnement",
    fixedRingHelp:
      "Andelen av din brutto månedslønn som går til faste abonnement akkurat nå. Beregnet som aktive abonnement pr. mnd. ÷ (siste årslønn brutto ÷ 12).",
    ringOfSalary: "av månedslønn",
    ringNoSalaryLabel: "TOTAL / MND",
    ringNoSalaryHint: "Legg inn lønn for å se abonnement som andel av inntekt.",
    realGrowthHelp:
      "Lønnsøkningen din justert for inflasjon — om pengene dine faktisk kjøpte mer i år, selv om tallet på lønnsslippen gikk opp.",
    purchasingPowerHelp:
      "Denne delen sammenligner inntektsveksten din mot inflasjon for det valgte året, slik at du kan se om du fikk mer eller mindre handlingsrom i realiteten.",
    categoriesHelp:
      "Hvordan de månedlige abonnementsutgiftene dine fordeler seg på kategori, basert på dine aktive abonnement.",
    cpiHelp:
      "Hvor mye prisene i Norge har steget det siste året, målt ved konsumprisindeksen (KPI) fra Statistisk sentralbyrå.",
    nominalRaise: "LØNNSØKNING {{year}}",
    realRaise: "REELT LØNNSLØFT (ETTER INFLASJON)",
    nominalVsRealTitle: "LØNN VS REELL VERDI",
    nominalVsRealHelp:
      "Faktisk lønn (heltrukket) mot samme lønn uttrykt i {{year}}-kroner (stiplet). Avstanden er kjøpekraft tapt til inflasjon.",
    legendNominal: "Lønn",
    legendReal: "Reell ({{year}}-kr)",

    cumulativeAhead:
      "Siden {{year}} har prisene steget {{cpi}} og lønnen din {{sal}} — du ligger {{diff}} foran i reelle termer.",
    cumulativeBehind:
      "Siden {{year}} har prisene steget {{cpi}} og lønnen din {{sal}} — du ligger {{diff}} bak i reelle termer.",
    subsShareLabel: "ABO / LØNN",
    subsAnnualLabel: "PR. ÅR",
    subsSavedLabel: "SPART VED PAUSE",
    subsSavedSub: "{{count}} pauset",
    percentOfSalary: "{{value}} av månedslønn",
  },
  subs: {
    eyebrow: "Abonnement",
    one: "avtale",
    many: "avtaler",
    loading: "Laster…",
    emptyFilter: "Ingen avtaler i denne kategorien.",
    pause: "Pause",
    newSub: "Nytt abonnement",
    deleteConfirm: "Slette {{name}}?",
    deleted: "Slettet",
    updated: "Oppdatert",
    added: "Lagt til",
    step: "Steg {{n}} av 4",
    edit: "Rediger",
    manualHeader: "Manuell registrering",
    chooseTitle: "Nytt abonnement",
    chooseQuestion: "Hvordan vil du legge til abonnementet?",
    selectService: "Velg tjeneste",
    selectServiceBody: "Finn raskt fra katalog med priser per land",
    recommended: "Anbefalt",
    manual: "Manuell registrering",
    manualBody: "Legg inn detaljer selv hvis tjenesten ikke finnes",
    pickService: "Velg tjeneste",
    pickPlan: "Velg plan",
    review: "Bekreft",
    searchPlaceholder: "Søk tjeneste eller kategori…",
    noResults: "Ingen treff.",
    country: "Land",
    fromCatalog: "Fra katalog — juster om nødvendig.",
    fields: {
      name: "Navn",
      category: "Kategori",
      cycle: "Syklus",
      cost: "Kostnad",
      currency: "Valuta",
      startDate: "Startdato",
      active: "Aktiv",
    },
    trackTitle: "Spor et abonnement",
    editTitle: "Rediger abonnement",
    enterManually: "Legg inn manuelt",
    useCatalog: "Bruk katalog",
    serviceSearchPlaceholder: "Søk strømming, musikk, nyheter…",
    plansCount: "{{n}} planer",
    plansCountOne: "1 plan",
    addSubscription: "Legg til abonnement",
    saveChanges: "Lagre endringer",
    section: {
      catalog: "Katalog",
      service: "Tjeneste",
      plan: "Plan",
      details: "Detaljer",
    },
    save: "Lagre",
    validation: {
      nameRequired: "Navn er påkrevd",
      costPositive: "Må være positiv",
      currencyLen: "Valuta må være 3 tegn",
      statusRequired: "Status er påkrevd",
    },
    monthlySpend: "Månedlig forbruk",
    activeYear: "{{count}} aktive · {{yearly}} / år",
    statMonthly: "Månedlig",
    statAnnual: "Årlig",
    statSavings: "Besparelse",
    runRate: "Løpende",
    unused: "{{n}} ubrukt",
    trendEmpty: "Trend vises når du har minst to måneder med sporede abonnementer.",
    listTitle: "Abonnementer",
    total: "{{n}} totalt",
    next: "Neste",
    creepTitle: "ABONNEMENTSVEKST",
    creepHelp:
      "Hvordan din månedlige abonnementssum har vokst etter hvert som du har lagt til tjenester. Bruker startdatoen til hvert abonnement.",
    creepAxisFrom: "{{value}}/mnd i {{year}}",
    creepAxisNow: "{{value}}/mnd nå",
    breakdownTitle: "PR. KATEGORI",
    breakdownHelp: "Hvordan din aktive månedlige abonnementskostnad fordeler seg på kategorier.",
    filterActive: "Aktive",
    filterPaused: "Pauset",
    filterUnknown: "Ukjent",
    filterAll: "Alle",
    sortLabel: "Sorter",
    statusLabel: "Status",
    unknown: "Ukjent",
    statusPlaceholder: "Velg status",

    categoryLabel: "Kategori",
    categoryAll: "Alle kategorier",

    sortCostDesc: "Høyest kostnad",
    sortCostAsc: "Lavest kostnad",
    sortNameAsc: "Navn (A–Å)",
    sortDateDesc: "Nyeste først",
    filterSummary: "{{count}} · {{value}}/mnd",
    percentOfSalary: "{{value}} av månedslønn",
    percentOfSalaryHelp:
      "Din totale aktive abonnementssum pr. mnd. delt på siste brutto månedslønn (siste årslønn ÷ 12).",
    inBaseYearKroner: "i {{year}}-kroner",
    realCostTitle: "REELL KOSTNAD",
    realCostHelp:
      "Din nåværende månedlige abonnementssum omregnet til det tidligste sporede lønnsårets kroner ved bruk av kumulativ norsk KPI — hva dagens forbruk ville føles ut som den gang.",
  },
  salary: {
    eyebrow: "Lønn & kjøpekraft",
    none: "Ingen lønn registrert",
    growth: "Lønnsøkning",
    cpi: "Inflasjon",
    real: "Reell endring",
    realGrowth: "REALLØNNSVEKST",
    history: "LØNNSHISTORIKK",
    total: "{{n}} totalt",
    pageIndicator: "Side {{current}} av {{total}}",
    emptyHistory: "Legg til din første lønnsoppføring for å se utviklingen.",
    newSalary: "Ny lønn",
    legendGrowth: "Lønnsøkning",
    legendCpi: "Inflasjon",
    firstRunHint:
      "Legg inn årslønnen din for hvert år. VISIKT regner da ut hvor mye kjøpekraften din faktisk har endret seg, justert for inflasjon.",
    fixedSalary: "Fastlønn",
    bonusLabel: "Bonus",
    vacationPayLabel: "Feriepenger",
    otherIncomeLabel: "Annen inntekt",
    totalPaid: "Sum utbetalt",
    benefitsLabel: "Goder",
    benefitsNotPaidOut: "Goder",
    benefitsNotPaidOutHelp:
      "Verdier du mottar fra arbeidsgiver som ikke utbetales i penger, for eksempel dekket mobilabonnement eller forsikring. Kalles naturalytelser på lønnsslippen. Inngår ikke i sum utbetalt.",
    vacationReplacesSalary: "Feriepenger",
    vacationReplacesSalaryHelp:
      "Feriepenger er opptjent lønn fra året før som utbetales når du tar ferie, i stedet for vanlig lønn. Den kommer derfor ikke i tillegg til årslønnen din, og inngår ikke i sum utbetalt.",
    sinceYear: "siden {{year}}",
    realChangeCaption: "reell endring · etter inflasjon",
    nominalShort: "Lønnsøkning",
    inflationShort: "Inflasjon",
    expandRow: "Vis detaljer for {{year}}",
    collapseRow: "Skjul detaljer for {{year}}",

    dialog: {
      titleNew: "Ny lønnsoppføring",
      titleEdit: "Rediger oppføring",
      gross: "Brutto årslønn (NOK)",
      effective: "Gjelder fra",
      bonusOptional: "Bonus (valgfri)",
      extraTitle: "Tilleggskompensasjon",
      vacationPay: "Feriepenger",
      vacationPayHint:
        "Feriepenger er opptjent lønn fra året før som utbetales når du tar ferie, i stedet for vanlig lønn. Den erstatter lønn og kommer ikke i tillegg — derfor vises den separat og inngår ikke i sum utbetalt.",
      benefits: "Goder",
      benefitsHint:
        "Verdier du får fra arbeidsgiver som ikke utbetales i penger, for eksempel firmabil, dekket mobilabonnement eller forsikring. Kalles naturalytelser på lønnsslippen.",

      otherIncome: "Annen inntekt",
      notes: "Notat",
      errInvalidNumber: "Skriv inn et gyldig tall.",
      errNegative: "Verdien må være null eller høyere.",
      errTooLarge: "Verdien er for stor.",
      errDateRequired: "Velg en dato.",
      errFutureDate: "Datoen kan ikke være i framtiden.",
    },
    confirmDelete: "Slette denne lønnsoppføringen?",
    statsTitle: "STATISTIKK",
    statsMetric: "Måltall",
    statsRange: "Periode",
    rangeAll: "Alle",
    rangeLast3: "3 år",
    rangeLast5: "5 år",
    rangeLast10: "10 år",
    rangeCustom: "Egendefinert",
    statsFrom: "Fra",
    statsTo: "Til",
    yearsSuffix_one: "{{count}} år",
    yearsSuffix_other: "{{count}} år",
    needTwoYears: "Trenger minst to år med data.",
    metrics: {
      totalEarned: "Totalt opptjent",
      totalEarnedHelp: "Sum av brutto årslønn for hvert år i perioden.",
      avgSalary: "Gjennomsnittslønn",
      avgSalaryHelp: "Gjennomsnittlig brutto årslønn i perioden.",
      cumGrowth: "Akkumulert vekst",
      cumGrowthHelp: "Lønnsendring fra første til siste år i perioden.",
      cagr: "Snitt årlig vekst",
      cagrHelp: "Årlig sammensatt vekstrate (CAGR) for lønn.",
      cumCpi: "Akkumulert KPI",
      cumCpiHelp: "Sammensatt inflasjon i perioden.",
      avgCpi: "Snitt årlig KPI",
      avgCpiHelp: "Årlig sammensatt inflasjonsrate.",
      cumReal: "Akkumulert reell",
      cumRealHelp: "Reell (inflasjonsjustert) lønnsendring i perioden.",
      avgReal: "Snitt årlig reell",
      avgRealHelp: "Årlig sammensatt reell vekst.",
      purchasingPower: "Kjøpekraft",
      purchasingPowerHelp: "Dagens lønn uttrykt i kroner fra første år.",
    },
    realHelp:
      "Lønnsøkningen din justert for inflasjon. Stiger lønnen 4 % mens prisene stiger 5 %, har kjøpekraften din falt — selv om du tjener mer.",
    cpiHelp:
      "Hvor mye prisene i Norge har steget det siste året, målt ved konsumprisindeksen (KPI) fra Statistisk sentralbyrå.",
    growthHelp: "Hvor mye lønnen din har økt siden året før, før det er tatt hensyn til inflasjon.",

    cpiProvisionalHelp:
      "Årets offisielle inflasjonstall er ikke publisert ennå (SSB publiserer dette hver januar for året før). Dette er et foreløpig anslag basert på siste tilgjengelige månedstall, og kan endre seg når det endelige tallet publiseres.",
    statsMetricHelp_totalEarned: "Summen av lønnen din i alle årene i det valgte tidsrommet.",
    statsMetricHelp_avgSalary: "Gjennomsnittlig årslønn i det valgte tidsrommet.",
    statsMetricHelp_cumGrowth:
      "Hvor mye lønnen din vokste totalt fra første til siste år i dette tidsrommet, i prosent.",
    statsMetricHelp_cagr:
      "CAGR (gjennomsnittlig årlig vekstrate) er din gjennomsnittlige årlige vekst, jevnet ut over hele tidsrommet — en mer rettferdig måte å sammenligne vekst over ulike tidsperioder enn et enkelt gjennomsnitt.",
    statsMetricHelp_cumCpi:
      "Hvor mye prisene steg totalt i det valgte tidsrommet, sammensatt år for år — ikke bare lagt sammen.",
    statsMetricHelp_avgCpi: "Gjennomsnittlig årlig inflasjon i det valgte tidsrommet.",
    statsMetricHelp_cumReal:
      "Din totale reelle vekst (justert for inflasjon) i hele tidsrommet — det nærmeste du kommer ett enkelt tall på 'kom jeg faktisk foran?'",
    statsMetricHelp_avgReal: "Din gjennomsnittlige årlige realvekst i det valgte tidsrommet.",
    statsMetricHelp_purchasingPower:
      "Hva lønnen din faktisk er verdt i dag, uttrykt i kjøpekraften til det første året i dette tidsrommet. Viser om pengene dine strekker til mer eller mindre enn før.",
  },
  profile: {
    eyebrow: "Profil",
    title: "Innstillinger",
    email: "E-post",
    name: "Navn",
    namePlaceholder: "Ditt navn",
    account: "KONTO",
    currency: "Valuta",
    updated: "Profil oppdatert",
    personal: "PERSONLIGE OPPLYSNINGER",
    firstName: "Fornavn",
    lastName: "Etternavn",
    postalCode: "Postnummer",
    city: "By",
    country: "Land",
    phone: "Telefonnummer",
    occupation: "Yrke",
    plan: "PLAN",
    currentPlan: "Nåværende plan",
    nextBilling: "Neste fakturering",
    downgradeScheduled: "Pro til {{date}}, deretter Gratis.",
    upgrade: "Oppgrader til Pro",
    downgrade: "Avslutt abonnement",
    undoDowngrade: "Behold Pro",
    downgradeScheduledToast: "Oppsigelse planlagt — du beholder Pro ut perioden.",
    undoDowngradeToast: "Oppsigelsen er reversert — du har fortsatt Pro.",
    manageBilling: "Administrer fakturering (fakturaer, kort)",
    pastDue:
      "Siste betaling mislyktes. Oppdater kortet under «Administrer fakturering» for å beholde Pro.",
    activatingSoon: "Aktiveres snart",
    legal: { title: "JURIDISK", terms: "Brukervilkår", privacy: "Personvernerklæring" },
    support: "SUPPORT",
    contactSupport: "Kontakt support",

    danger: "FARESONE",
    deleteAccount: "Slett konto",
    deleteConfirmTitle: "Slette kontoen din?",
    deleteConfirmBody:
      "Dette sletter profilen, abonnementene og lønnshistorikken din permanent. Dette kan ikke angres.",
    deleteConfirmAction: "Ja, slett alt",
    deleting: "Sletter…",
    deleted: "Kontoen din er slettet.",
    deleteFailed: "Kunne ikke slette kontoen. Prøv igjen eller kontakt support.",
    dataSection: "DINE DATA",
    exportCsv: "Eksporter data (CSV)",
    exportReady: "Eksport klar",
    nothingToExport: "Ingenting å eksportere ennå",
    exportProOnly: "CSV-eksport er en Pro-funksjon.",
  },

  ribbon: {
    free: "Du er på Gratis-planen · Oppgrader til Pro",
  },
  addExtra: {
    upgradeOption: "Oppgrader til Pro",
    upgradeBody: "Lås opp ubegrenset antall abonnementer, full lønnshistorikk og statistikk.",
  },
  categories: {
    streaming: "Strømming",
    music: "Musikk",
    audiobooks: "Lydbøker",
    ai: "AI",
    productivity: "Produktivitet",
    cloud_storage: "Skylagring",
    telecom: "Telekom",
    fitness: "Trening",
    news: "Nyheter",
    software: "Programvare",
    gaming: "Gaming",
    vpn: "VPN",
    transport: "Transport",
    food_delivery: "Matlevering",
    social_media: "Sosiale medier",
    communication: "Kommunikasjon",
    other: "Annet",
  },
  cycles: {
    monthly: "Månedlig",
    quarterly: "Kvartalsvis",
    yearly: "Årlig",
  },
  countries: {
    NO: "Norge",
    SE: "Sverige",
    DK: "Danmark",
  },
  add: {
    eyebrow: "Legg til",
    title: "Hva vil du legge til?",
    subOption: "Legg til abonnement",
    subBody: "Faste tjenester — strømming, telekom, trening og mer.",
    incomeOption: "Registrer lønn / inntekt",
    incomeBody: "Spor lønnsvekst, bonus og kjøpekraft.",
    incomeLocked: "Tilgjengelig etter at du har lagt til ditt første abonnement.",
  },
  subsExtra: {
    catalogUpdated: "Katalogpris oppdatert",
    updateTo: "Oppdater til {{value}}",
    priceUpdated: "Pris oppdatert",
    catalogPriceChangedHelp:
      "Prisen for denne planen i katalogen vår har endret seg siden du la den til. Det lagrede beløpet ditt endres ikke automatisk — oppdater det manuelt hvis du vil matche den nye katalogprisen.",
  },
  salaryExtra: {
    type: "Type",
    typeSalary: "Lønn",
    typeRaise: "Lønnsøkning",
    typeBonus: "Bonus",
    typeOther: "Annet",
  },
  admin: {
    title: "Admin",
    eyebrow: "Katalog og inflasjon",
    tabs: { catalog: "Katalog", inflation: "Inflasjon" },
    overview: "Oversikt",
    services: "Tjenester",
    plans: "Planer",
    needsVerify: "Trenger ny verifisering",
    backToApp: "Tilbake til app",
    filters: { country: "Land", category: "Kategori", active: "Aktiv" },
    columns: {
      service: "Tjeneste",
      plan: "Plan",
      price: "Pris",
      cycle: "Syklus",
      category: "Kategori",
      verified: "Sist verifisert",
      active: "Aktiv",
      source: "Kilde",
      actions: "",
    },
    addService: "Ny tjeneste",
    addPlan: "Ny plan",
    fetchApi: "Hent fra API",
    fetchApiBody: "Auto-henting er ikke konfigurert ennå. Oppdater priser manuelt over.",
    notes: "Notat",
    saved: "Lagret",
    deleted: "Slettet",
    confirmDelete: "Slette denne oppføringen?",
    inflation: {
      title: "Årlig inflasjon",
      year: "År",
      rate: "Rate %",
      source: "Kilde",
      add: "Legg til år",
      kind: "Type",
      kindArsvekst: "Årsvekst (offisiell)",
      kindTolv: "12-mnd. endring (foreløpig)",
      asOfMonth: "Måned (1–12)",
      invalidMonth: "Ugyldig måned (1–12)",
      kindHelp:
        "Bruk «Årsvekst» for fullførte år — dette er SSBs offisielle, endelige tall, publisert i januar året etter. Bruk «12-mnd. endring» kun for det pågående året, før årsveksten er klar. Årsvekst overstyrer alltid en 12-mnd.-rad for samme år.",
    },
    accessDenied: "Du har ikke admintilgang.",
    open: "Åpne admin",
  },
  pricing: {
    eyebrow: "Priser",
    headline: "Enkle, ærlige priser.",
    body: "Start gratis. Oppgrader når VISIKT viser seg verdt det i din økonomi.",
    trialBadge: "14 dager gratis",
    noTrialNote: "Ingen prøveperiode — start med gratis-nivået og oppgrader når du vil.",
    free: {
      name: "Gratis",
      price: "0",
      description: "Det viktigste, alltid gratis.",
      cta: "Kom i gang gratis",
      features: [
        "Opptil 3 abonnementer",
        "Opptil 3 år med lønnshistorikk",
        "Dashbord-oversikt",
        "Norsk KPI-inflasjonsdata for inneværende år",
      ],
    },
    pro: {
      name: "Pro",
      priceMonthly: "79",
      priceYearly: "690",
      perMonth: "/ mnd",
      perYear: "/ år",
      yearlySaving: "Spar 27 %",
      description: "Full finansiell klarhet, uten begrensninger.",
      ctaWithTrial: "Start 14 dager gratis",
      ctaNoTrial: "Få Pro",
      features: [
        "Ubegrenset antall abonnementer",
        "Full lønnshistorikk",
        "Statistikkutforsker - metrikk × periode-filter",
        "Eksporter data som CSV",
        "Abonnementer i flere valutaer",
        "Historisk norsk KPI-inflasjonsdata ",
      ],
    },
    billingToggle: {
      monthly: "Månedlig",
      yearly: "Årlig",
    },
    faq: {
      title: "Vanlige spørsmål",
      q1: "Kan jeg bytte plan senere?",
      a1: "Ja. Oppgrader eller nedgrader når som helst.",
      q2: "Hva skjer med dataene mine hvis jeg nedgraderer?",
      a2: "Dataene dine beholdes. Har du mer enn 3 abonnementer eller 3 år med lønnsdata, bevares eksisterende oppføringer, men de vil ikke være synlig og du kan heller ikke legge til nye før du oppgraderer igjen.",
      q3: "Er de økonomiske dataene mine trygge?",
      a3: "Ja. All data lagres i henhold til gjeldene personvern og GDPR regler, bare du kan lese dine data. Vi selger eller deler dem aldri.",
      q4: "",
      a4: "",
      stillHave: "Fortsatt spørsmål?",
      contactCta: "Kontakt support",
    },

    footer: "Alle priser inkluderer MVA der det er aktuelt. Faktureres i NOK.",
  },
  requestAccess: {
    eyebrow: "Tidlig tilgang",
    headline: "Be om en invitasjon.",
    body: "VISIKT er foreløpig kun tilgjengelig på invitasjon. Fyll ut skjemaet nedenfor, så sender vi deg en invitasjonslenke når plassen din er klar.",
    name: "Fullt navn",
    email: "E-postadresse",
    heardAbout: "Hvor hørte du om VISIKT?",
    heardAboutPlaceholder: "f.eks. Twitter, en venn, Product Hunt…",
    submit: "Send forespørsel",
    submitting: "Sender…",
    successHeadline: "Forespørsel mottatt.",
    successBody: "Takk — vi tar kontakt. Hold øye med innboksen din.",
    backToSignIn: "Tilbake til innlogging",
    namePlaceholder: "Alex Smith",
    errors: {
      submitFailed: "Noe gikk galt under sending av forespørselen. Prøv igjen om litt.",
    },
  },
  about: {
    eyebrow: "Om oss",
    headline: "Om VISIKT",
    intro:
      "VISIKT hjelper deg å se din økonomiske virkelighet, faste abonnementer, lønnsutvikling og reell (inflasjonsjustert) kjøpekraft på ett sted. Bygget for Norge først, med offisiell norsk KPI for å oversette lønnen din til reelle tall.",
    whatSectionTitle: "Hva VISIKT gjør",
    whatBody:
      "Hold oversikt over alle faste kostnader, logg lønnen din over tid, og se hvordan kjøpekraften faktisk endrer seg når inflasjonen er tatt med. Klarhet, ikke budsjettering.",
    companySectionTitle: "Selskapet bak VISIKT",
    companyBody:
      "VISIKT er bygget og driftet av VIKEEP AS, et lite uavhengig norsk selskap med blant annet fokus på personlig økonomisk klarhet.",
    orgNoLabel: "Org.nr",
    addressLabel: "Adresse",
    addressValue: "Oslo, Norge",
    contactLabel: "Kontakt",
    parentSiteLabel: "Morselskap",
    parentSiteValue: "www.vikeep.no",
  },
  privacy: {
    eyebrow: "Personvern",
    headline: "Personvernerklæring",
    lastUpdated: "Sist oppdatert: 30. juni 2026",
    intro:
      'Denne personvernerklæringen forklarer hvordan Vikeep AS ("Vikeep", "vi", "oss", "vår") samler inn og behandler personopplysninger når du bruker VISIKT ("Tjenesten") — vår app for å holde oversikt over abonnementer, lønn og inflasjonsjustert kjøpekraft. Vi behandler personopplysninger i samsvar med EUs personvernforordning (forordning (EU) 2016/679, "GDPR"), slik den er gjennomført i norsk rett gjennom personopplysningsloven.',
    tableHeaderPurpose: "Formål",
    tableHeaderBasis: "Behandlingsgrunnlag (GDPR artikkel 6)",
  },
  terms: {
    eyebrow: "Juridisk",
    headline: "Brukervilkår",
  },
  checkout: {
    confirmationEmailSubject: "VISIKT Pro-abonnementet ditt er aktivt",
    confirmationEmailHeadline: "Velkommen til VISIKT Pro",
    confirmationEmailIntroMonthly:
      "Takk for at du abonnerer. VISIKT Pro-planen din er aktiv og fornyes månedlig til {{price}} NOK inntil du sier opp.",
    confirmationEmailIntroYearly:
      "Takk for at du abonnerer. VISIKT Pro-planen din er aktiv og fornyes årlig til {{price}} NOK inntil du sier opp.",
    confirmationEmailWithdrawal:
      "Du ba uttrykkelig om at vi begynner å levere VISIKT Pro umiddelbart, og bekreftet at du taper den 14 dagers angreretten når tjenesten er fullt levert. Er leveringen bare delvis påbegynt, kan du likevel skylde et beløp som står i forhold til det som er levert.",
    confirmationEmailManage:
      "Du kan se fakturaer, nedgradere eller si opp når som helst under Profil i appen.",
    confirmationEmailLinks:
      "Vilkår: https://visikt.com/terms · Personvern: https://visikt.com/privacy",
    confirmationEmailFooter: "VIKEEP AS · org.nr 938 008 272 · Oslo, Norge · contact@vikeep.no",
  },
} as const;

export default nb;
